<app-header></app-header>

<div class="section container mt-5">
  <div class="card-title">
    <h1>Preview Details Before Submission</h1>
  </div>
  <div class="card mb-3">
    <div class="card-header"><h2>Personal Details</h2></div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-2">
            <label class="text-dark">Name Of Organisation</label>
            <input type="text" class="form-control" id="txtOrgName" name="orgname" [value]="formData?.NameOfOrganisation" disabled />

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-2">
            <label class="text-dark"> Short Name Of Organisation</label>
            <input type="text" class="form-control" id="shorttxtOrgName" name="shortorgname" [value]="formData?.ShortNameOfOrganisation" disabled />

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-2">
            <label class="text-dark">Address</label>
            <input type="text" class="form-control" id="address" name="address" [value]="formData?.AddressOfOrganisation" disabled />

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-2">
            <label class="text-dark">Email</label>
            <input type="text" class="form-control" id="email" name="email" [value]="formData?.Email" disabled />

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="mb-2">
            <label class="text-dark">Mobile Number</label>
            <input type="text" class="form-control" id="txtMobNum" name="mobnum" [value]="formData?.MobileNumber" disabled />

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-2">
            <label class="text-dark">Contact Number</label>
            <input type="text" class="form-control" id="txtContactNumber" name="ContactNumber" [value]="formData?.ContactNumber" disabled />

          </div>
        </div>
        
        <!--<div class="col-md-2">-->
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-2">
            <label class="text-dark">Focus Sector Name</label>
            <!--<input type="text" class="form-control" id="focusSectorName" name="focusSectorName" [value]="formData?.focusSectorName" disabled />-->
            <textarea class="form-control" id="focusSectorName" name="focusSectorName" [value]="formData?.focusSectorName" disabled></textarea>
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="card mb-3">
    <div class="card-header"> <h2>SPOC Details</h2></div>
    <div class="card-body">
      <div class="row">
        <div class="table-responsive ">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Spoc Name</th>
                <th>Spoc Designation</th>
                <th>Spoc Email</th>
                <th>Spoc Mobile</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let unit of formData.iaRegistrationSpocDetails,let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ unit.SpocName }}</td>
                <td>{{ unit.SpocDesignation }}</td>
                <td>{{ unit.SpocEmail }}</td>
                <td>{{ unit.SpocMobile }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="card mb-3">
    <div class="card-header"> <h2>RAMP</h2></div>
    <div class="card-body">

      <div class="row">
        <div class="table-responsive ">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Intervention</th>
                <th>Interest</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let unit of formData.iaUserInterests,let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ unit.interventionName }}</td>
                <td>{{ unit.interestName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
 


  <form [formGroup]="form1">
    <div class="col-md-12 mt-3">

      <div class="row">
        <label style="text-align: justify; font-size: 13px;">
          <b>Declaration<span class="text-danger">*</span> :&nbsp;&nbsp;</b>
          <input type="checkbox"
                 formControlName="termsConditionAccepted" />
          The information I/ we have furnished/ will furnish at various stages of engagement with MSSIDC, Government of Maharashtra, Government of India and The World Bank is correct to the best of my/ our knowledge. I/ we understand that any willful misstatement described herein may lead to my/ our organization's disqualification as Implementation Agency under the Programme.
        </label>
      </div>
      <br />
      <div class="row">
        <label style="text-align: justify; font-size: 13px;">
          <b>Third Party Data usage undertaking<span class="text-danger">*</span> :&nbsp;&nbsp;</b>
          <input type="checkbox"
                 formControlName="thirdPartyUndertaking" />
          I/ we understand that any data provided to us by MSSIDC in relation to the RAMP Programme is strictly for the purpose of authorized implementation of the programme components. I/ we understand that we do not have the authority to share this data with any other person unless so authorized by MSSIDC.
        </label>
      </div>

      <div class="row">
        <label for="captcha">Please enter the text below:</label>
        <div>
          <canvas id="captchaCanvas" width="150" height="60"></canvas>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-6 mt-2"><input type="text" placeholder="Enter CAPTCHA" formControlName="captcha" class="form-control pull-left" /></div>
          <div class="col-md-6 col-xs-6 mt-2"><button (click)="generateCaptcha()" class="btn btn-primary">Refresh Captcha</button></div>
          <div *ngIf="f['captcha'].errors && f['captcha'].errors['required']" class="alert alert-danger required" style="width:161px">
            captcha is requried
          </div>
        </div>

      </div>
      <p *ngIf="captchaError" style="color: red;">Invalid CAPTCHA!</p>
      <p *ngIf="captchaSuccess" style="color: green;">CAPTCHA verified successfully</p>


      <br />
    </div>
  </form>
</div>

    

  
<div class="text-center mb-2 mb-md-5">
  <!--<button id="btnBack" type="button" class="btn btn-danger" (click)="goBack()">Back</button>&nbsp;-->

  <button id="btnsave" type="button" class="btn btn-success" (click)="SaveUser()">Save</button>
  <button  class="btn btn-secondary mx-2" (click)="navigateBack()">Back</button>
  <button id="btncancel" type="reset" class="btn btn-danger" [routerLink]="'/login'">Cancel</button>
</div>

  <app-footer></app-footer>
